import { render, staticRenderFns } from "./Wedding.vue?vue&type=template&id=4e1516ba"
import script from "./Wedding.vue?vue&type=script&lang=js"
export * from "./Wedding.vue?vue&type=script&lang=js"
import style0 from "./Wedding.vue?vue&type=style&index=0&id=4e1516ba&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports